/* unplugin-vue-components disabled */import script from "./FooterContent.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterContent.vue?vue&type=script&setup=true&lang=js"

import "./FooterContent.vue?vue&type=style&index=0&id=884c7a42&lang=scss&scoped=true"

import exportComponent from "D:\\pangu_artificial_intelligence_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-884c7a42"]])

export default __exports__